import { render } from "./CombinedPayments.vue?vue&type=template&id=44d3cd87"
import script from "./CombinedPayments.vue?vue&type=script&lang=js"
export * from "./CombinedPayments.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__